import { useState, useEffect } from "react";
import api from "../../services/api";

const box = { marginBottom: 16, padding: 14, background: "white", border: "1px solid #e5e7eb", borderRadius: 10 };
const heading = { fontSize: 11, fontWeight: 700, color: "#0B2545", textTransform: "uppercase", letterSpacing: 0.4, display: "block", marginBottom: 6 };

/**
 * Directory side of the link: which registered provider account(s) use this listing's NPI, and the
 * PRACTICES they treat patients at. Read-only: practices are changed in Manage Practices & Providers.
 * Stays out of the way: renders nothing while loading, or if it can't load (for example a researcher
 * opening this page; the data is admin-only).
 */
export default function LinkedAccountsPanel({ npi }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get(`/v1/admin/providers/${npi}/linked-accounts`)
      .then((res) => !cancelled && setData(res.data))
      .catch(() => !cancelled && setData(null));
    return () => {
      cancelled = true;
    };
  }, [npi]);

  if (!data) return null;

  return (
    <div style={box}>
      <label style={heading}>Registered provider account</label>
      {data.accounts.length === 0 ? (
        <p style={{ fontSize: 12, color: "#9ca3af", margin: 0 }}>No registered provider account uses this NPI.</p>
      ) : (
        data.accounts.map((a) => (
          <div key={a.providerAccountId} style={{ fontSize: 12, color: "#374151", marginBottom: 6 }}>
            <strong>{a.name}</strong> <span style={{ color: "#9ca3af" }}>({a.email})</span>
            {a.blocked && <span style={{ marginLeft: 6, color: "#dc2626", fontWeight: 700 }}>Blocked</span>}
            <div style={{ marginTop: 2 }}>
              <span style={{ color: "#6b7280" }}>Practices (treats patients at): </span>
              {a.practices.length === 0 ? "none" : a.practices.map((p) => (p === a.activePractice ? `${p} (active)` : p)).join(", ")}
            </div>
          </div>
        ))
      )}
      <p style={{ fontSize: 11, color: "#9ca3af", margin: "6px 0 0" }}>
        Practices decide which patients a provider can see. Change them in{" "}
        <a href="/admin/manage-practices" style={{ color: "#1A5EA8" }}>Manage Practices &amp; Providers</a>.
      </p>
    </div>
  );
}
